import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllOrganizationsUserUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllOrganizationsUser
  implements GetAllOrganizationsUserUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllOrganizationsUserUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllOrganizationsUserUseCaseInterface.Params,
  ): Promise<GetAllOrganizationsUserUseCaseInterface.Result> {
    let requestUrl = this.url;
    if (params?.course) {
      requestUrl += `?course=${params?.course}`;
    }

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
